export default "__VITE_ASSET__DEYA3gvB__"